import React from "react";
import { Table } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { dateAddYears } from "../../Utilities/dateUtils";
import {
  aplLicenseWillBeExtended,
  formatLicenseDate,
} from "../../Utilities/licenseHelper";

const CartStudentList = (props) => {
  const showAplColumn = Boolean(props.aplYears);

  let studentList = props.addedStudentList.map((p, i) => (
    <tr key={i}>
      <td className="ps-0">{p.name}</td>
      <td className="ps-0">{p.class.name}</td>
      {showAplColumn && (
        <td className="ps-0">
          {aplLicenseWillBeExtended(p.licenses) ? (
            <FormattedMessage
              id="StudentAplLicenseWillBeExtended"
              values={{
                dateFrom: formatLicenseDate(p.licenses.aplLicenseValidFrom),
                dateUntil: formatLicenseDate(p.licenses.aplLicenseValidTo),
                newDateUntil: formatLicenseDate(
                  dateAddYears(p.licenses.aplLicenseValidTo, props.aplYears),
                ),
              }}
            />
          ) : (
            <FormattedMessage
              id="StudentGetsNewAplLicense"
              values={{
                dateFrom: formatLicenseDate(props.aplStartDate),
                dateUntil: formatLicenseDate(
                  dateAddYears(props.aplStartDate, props.aplYears),
                ),
              }}
            />
          )}
        </td>
      )}
    </tr>
  ));

  return (
    <Table responsive>
      <thead>
        <tr>
          <th className="ps-0" style={{ borderTop: "none" }}>
            <FormattedMessage id="Name" />
          </th>
          <th className="ps-0" style={{ borderTop: "none" }}>
            <FormattedMessage id="Class" />
          </th>
          {showAplColumn && (
            <th className="ps-0" style={{ borderTop: "none" }}>
              <FormattedMessage id="AplLicense" />
            </th>
          )}
        </tr>
      </thead>
      <tbody>{studentList}</tbody>
    </Table>
  );
};

export default CartStudentList;
